import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { "txt-center": "" }
const _hoisted_3 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_form_title = _resolveComponent("app-form-title")!
  const _component_ForgotEmailSent = _resolveComponent("ForgotEmailSent")!
  const _component_Message = _resolveComponent("Message")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_create_account_links = _resolveComponent("app-create-account-links")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_app_form_holder = _resolveComponent("app-form-holder")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_app_form_holder, null, {
      default: _withCtx(() => [
        _createVNode(_component_app_form_title, { title: "Forgotten your password?" }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode(" No problem. Let us know where ", -1),
            _createElementVNode("br", null, null, -1),
            _createTextVNode(" to send the password reset email ", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("div", null, [
          (_ctx.sentInstructions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ForgotEmailSent)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.sentInstructions)
            ? (_openBlock(), _createBlock(_component_el_form, {
                key: 1,
                rules: _ctx.rules,
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                class: "App-Styled-Form",
                "label-position": 'top',
                "label-width": "100px",
                model: _ctx.form,
                style: {"margin-top":"12px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "email",
                    label: "Email"
                  }, {
                    label: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Message)
                        ]),
                        _: 1
                      }),
                      _cache[3] || (_cache[3] = _createTextVNode(" Email ", -1))
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        placeholder: "johndoe@e4t.com",
                        modelValue: _ctx.form.email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_el_button, {
                      disabled: !_ctx.form.email,
                      "is-block": "",
                      size: "large",
                      type: "primary",
                      icon: "el-icon-check",
                      onClick: _ctx.submit
                    }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode(" Send reset email ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ])
                ]),
                _: 1
              }, 8, ["rules", "model"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_el_divider),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_space, {
            "w-100": "",
            fill: true,
            alignment: "center",
            direction: "vertical",
            size: 4
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_router_link, { to: "/login" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_link, { type: "primary" }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("Sign In", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("div", null, [
                _createElementVNode("span", null, "Don't have an account?")
              ], -1)),
              _createVNode(_component_app_create_account_links)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}